import React from 'react';

// variant: 'transaction-list' | 'ir-summary' | 'ir-cards' | 'recurring-list'
function SkeletonLoader({ variant = 'transaction-list', count = 5 }) {
  const rows = Array.from({ length: count }, (_, i) => i);

  if (variant === 'transaction-list') {
    return (
      <div className="space-y-2 animate-pulse">
        {rows.map(i => (
          <div key={i} className="flex items-center justify-between p-4 rounded-xl border border-slate-100">
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 rounded-xl bg-slate-200" />
              <div>
                <div className="h-4 w-36 bg-slate-200 rounded mb-2" />
                <div className="h-3 w-24 bg-slate-100 rounded" />
              </div>
            </div>
            <div className="flex items-center space-x-6">
              <div className="hidden md:block h-5 w-16 bg-slate-100 rounded-md" />
              <div className="h-5 w-20 bg-slate-200 rounded" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (variant === 'ir-summary') {
    return (
      <div className="space-y-8 animate-pulse">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[0, 1, 2].map(i => (
            <div key={i} className="bg-white p-8 rounded-xl border border-slate-100 shadow-sm">
              <div className="h-3 w-28 bg-slate-200 rounded mb-6" />
              <div className="h-9 w-40 bg-slate-200 rounded mb-3" />
              <div className="h-3 w-20 bg-slate-100 rounded" />
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2 bg-white rounded-xl border border-slate-100 shadow-sm p-8">
            <div className="h-5 w-40 bg-slate-200 rounded mb-8" />
            <div className="h-64 bg-slate-100 rounded-xl" />
          </div>
          <div className="flex flex-col gap-4">
            {[0, 1, 2].map(i => (
              <div key={i} className="bg-slate-50 rounded-xl p-6 border border-slate-100">
                <div className="h-3 w-24 bg-slate-200 rounded mb-2" />
                <div className="h-6 w-32 bg-slate-200 rounded" />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  if (variant === 'recurring-list') {
    return (
      <div className="space-y-4 animate-pulse">
        {rows.map(i => (
          <div key={i} className="flex justify-between items-center p-4 border border-slate-100 rounded-xl">
            <div className="flex items-center space-x-4">
              <div className="w-10 h-10 bg-slate-200 rounded-lg" />
              <div>
                <div className="h-4 w-32 bg-slate-200 rounded mb-2" />
                <div className="h-3 w-20 bg-slate-100 rounded" />
              </div>
            </div>
            <div className="h-5 w-20 bg-slate-200 rounded" />
          </div>
        ))}
      </div>
    );
  }

  return null;
}

export default SkeletonLoader;
